var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"effect":_vm.effect,"content":_vm.content,"placement":_vm.placement,"disabled":!_vm.isOverflow}},[_c('div',{staticClass:"text-overflow-container",style:(_vm.boxStyle),on:{"mouseenter":_vm.checkOverflow}},[_vm._v(" "+_vm._s(_vm.content)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }